import React from 'react';
import useTranslation from '@src/hooks/useTranslation';
import styled from 'styled-components';

import { formatToDate } from '@src/utils/time';
import { BUTTON_VARIANT_OUTLINED } from '@src/const/common';

import Button from '@src/components/common/button';
import Modal from '@src/components/common/modal';
import ReviewItem from './reviewItem';

const Title = styled.div`
	margin-bottom: 24px;
	font-weight: 700;
	color: #101010;
	text-align: center;
`;

const EditButton = styled(Button)`
	width: 140px;
	padding: 8px 24px;

	@media ${props => props.theme.device.mobile} {
		width: 166px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

const CloseButton = styled(Button)`
	width: 140px;
	padding: 8px 24px;
	margin-left: 16px;

	@media ${props => props.theme.device.mobile} {
		width: 166px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 12px;
	}
`;

interface IUser {
	name: string;
	profile_picture_link?: {
		link: string;
	};
}
interface IReview {
	user: IUser;
	updated_at: number;
	rating: number;
	message: string;
}

interface IMyReviewModal {
	review: IReview;
	isActive: boolean;
	handleEdit: () => void
	handleClose: () => void;
}

const genModalFooter = ({ editTex, closeTex, handleEdit, handleClose }: {
	editTex: string;
	closeTex: string;
	handleEdit: () => void;
	handleClose: () => void;
}): JSX.Element => (
	<>
		<EditButton variant={BUTTON_VARIANT_OUTLINED} handleClick={handleEdit}>{editTex}</EditButton>
		<CloseButton handleClick={handleClose}>{closeTex}</CloseButton>
	</>
);

const MyReviewModal = ({ review, isActive, handleEdit, handleClose }: IMyReviewModal): JSX.Element => {
	const { t } = useTranslation();
	const modalFooter = genModalFooter({
		editTex: t('modal:edit_review'),
		closeTex: t('modal:close'),
		handleEdit,
		handleClose,
	});

	return (
		<Modal
			isActive={isActive}
			headerText={t('course:my_review')}
			footer={modalFooter}
			handleClose={handleClose}
		>
			<Title>{t('course:already_review_at_time', { date: formatToDate(review.updated_at) })}</Title>
			<ReviewItem
				avatar={review.user.profile_picture_link?.link}
				userName={review.user.name}
				updatedTime={review.updated_at}
				rating={review.rating}
				message={review.message}
			/>
		</Modal>
	);
};

export default MyReviewModal;
